/* eslint-disable */
import {Practice, submitPracticeProgress} from "../../../../api/lessonsService";
import React, {useEffect, useState} from "react";
import {useLessonStore} from "../../../../store/useLessonStore";

interface SingleChoiceTestPracticeProps {
    practice: Practice;
    lessonId: number;
    fragmentIndex: number;
    currentFragmentId: number;
    courseId: string;
    onHint: () => void;
    onSubmit: (selectedOption: string) => void;
    onCompleted?: () => void;
    onMoveNext?: () => void;
    isCompleted?: boolean;
}



export const SingleChoiceTestPractice: React.FC<SingleChoiceTestPracticeProps> = ({
 practice,
 lessonId,
 fragmentIndex,
 onHint,
 onSubmit,
 onCompleted,
 onMoveNext,
    currentFragmentId,
    courseId
}) => {
    const { lessonProgressData, lessonData, setLessonProgressData } = useLessonStore()
    const [selectedOption, setSelectedOption] = useState<string>('');
    const [showHint, setShowHint] = useState(false);
    const [showFeedback, setShowFeedback] = useState(false);
    const [isCorrect, setIsCorrect] = useState(false);
    const [isCompleted, setCompleted] = useState(false)
    const [isSkip, setSkipStatus] = useState(false)

    useEffect(() => {
        const currentFragment = lessonData?.fragments.find((fr: any) => fr.id === currentFragmentId);
        if (!currentFragment){
            setCompleted(false)
        }

        // Check if the current fragment has progress data
        const fragmentProgress = lessonProgressData.find((fp:any) => fp.fragmentId === currentFragment.id);
        if (!fragmentProgress || !fragmentProgress.practiceResults){
            setCompleted(false)
        }

        if(fragmentProgress?.practiceResults){
            if(fragmentProgress?.practiceResults?.answer === "SKIPPED"){
                setSkipStatus(true)
            }
        }

        // Check if this practice exists in the practice results
        setCompleted(fragmentProgress?.practiceResults?.practiceId === practice.id);
    }, [lessonProgressData, lessonData])

    // Get practice data from the server response
    const singleChoiceData = practice.singleChoiceTest;

    if (!singleChoiceData) {
        return (
            <div className="practice-block">
                <div className="practice-block-content">
                    <p>Practice data not available</p>
                </div>
            </div>
        );
    }

    const { question, hint, options, correctChoiceMessage, wrongChoiceMessage } = singleChoiceData;

    const handleHint = () => {
        setShowHint(!showHint);
        onHint();
    };

    const handleSubmit = async () => {
        if (selectedOption) {
            // Find the selected option to check if it's correct
            const selectedOptionData = options.find(option => option.text === selectedOption);
            const correct = selectedOptionData?.isCorrect || false;
            setIsCorrect(correct);
            setShowFeedback(true);
            onSubmit(selectedOption);

            // Submit practice progress
            try {
               const result =  await submitPracticeProgress(
                    {
                        courseId: courseId,
                        fragmentIndex: fragmentIndex,
                        fragmentId: currentFragmentId,
                        practiceId: practice.id,
                        lessonId: lessonId,
                        practiceType: practice.practiceType,
                        answer: selectedOption,
                        isCorrect: correct});

                setLessonProgressData([result])
            } catch (error) {
                console.error('Error submitting practice progress:', error);
            }

            onCompleted?.();
            onMoveNext?.();
        }
    };

    const handleOptionChange = (option: string) => {
        setSelectedOption(option);
        // Hide feedback when user changes their answer
        setShowFeedback(false);
    };

    return (
        <div className="practice-block">
            <div className="practice-block-content">
                <h3 className="practice-title">{question}</h3>

                <div className="practice-options">
                    {options.map((option) => (
                        <label key={option.id} className="practice-option">
                            <input
                                type="radio"
                                name={`practice-${practice.id}`}
                                value={option.text}
                                checked={selectedOption === option.text}
                                onChange={(e) => handleOptionChange(e.target.value)}
                                className="practice-radio"
                            />
                            <span className="practice-option-text">{option.text}</span>
                        </label>
                    ))}
                </div>

                {/* Hint Section */}
                {showHint && (
                    <div className="practice-hint-section">
                        <div className="practice-hint-content">
                            <p>{hint}</p>
                        </div>
                    </div>
                )}

                {/* Feedback Section */}
                {showFeedback && (
                    <div className={`practice-feedback-section ${isCorrect ? 'correct' : 'incorrect'}`}>
                        <div className="practice-feedback-content">
                            <h4 className="practice-feedback-title">
                                {isCorrect ? 'Correct answer' : 'Incorrect answer'}
                            </h4>
                            <p className="practice-feedback-text">
                                {isCorrect ? correctChoiceMessage : wrongChoiceMessage}
                            </p>
                        </div>
                    </div>
                )}

                {!isSkip && isCompleted ? <></> : (
                    <div className="practice-actions">
                        <button className="practice-hint-btn" onClick={handleHint}>
                            Hint
                        </button>
                        <button
                            className="practice-submit-btn"
                            onClick={handleSubmit}
                            disabled={!selectedOption}
                        >
                            Submit
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};
